// extracted by mini-css-extract-plugin
export var button = "add-shopping-list-modal-module--button--84gqJ";
export var errorMessage = "add-shopping-list-modal-module--error-message--O8fEg";
export var formAdd = "add-shopping-list-modal-module--form-add--ZgYx3";
export var formSelect = "add-shopping-list-modal-module--form-select--tldFE";
export var input = "add-shopping-list-modal-module--input--tdDYT";
export var modal = "add-shopping-list-modal-module--modal--y6YxS";
export var separator = "add-shopping-list-modal-module--separator--94U3m";